module.exports = __webpack_public_path__ + "static/MOD5-f4317244a9eccd68f1a8c6d7f4c0c30f.jpg";